import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";

// rest
import { getOemDetails, createOem, updateOem } from "../../../rest/oem";

class OemDetails extends React.Component { 

    state = {
        errMsg: "",
        scsMsg: ""
    }

    constructor(props) {
        super(props);
        this.nameRef = React.createRef();
        this.addressRef = React.createRef();
        this.priContactRef = React.createRef();
        this.priPhoneRef = React.createRef();
        this.priEmailRef = React.createRef();
        this.secContactRef = React.createRef();
        this.secPhoneRef = React.createRef();
        this.secEmailRef = React.createRef();
    }

    async componentDidMount() {
        try {
            if(this.props.match.params.oemId != 0){
                let res = await getOemDetails(this.props.match.params.oemId);
                this.setState({
                    oemData: res.data
                })
                this.nameRef.current.value = res.data.name;
                this.addressRef.current.value = res.data.address;
                this.priContactRef.current.value = res.data.primaryContact;
                this.priPhoneRef.current.value = res.data.primaryPhone;
                this.priEmailRef.current.value = res.data.primaryEmail;
                this.secContactRef.current.value = res.data.secondaryContact;
                this.secPhoneRef.current.value = res.data.secondaryPhone;
                this.secEmailRef.current.value = res.data.secondaryEmail;
            }
        } catch (e) {
            console.log(e);
        }
    }

    navToList = () =>{
        this.props.history.push(`/admin/oems`);
    }

    async postData() {
        try {
            this.setState({
                errMsg: "",
                scsMsg: ""
            })
            if(this.validate()){
                let data = {
                    name: this.nameRef.current.value,
                    address: this.addressRef.current.value,
                    primaryContact: this.priContactRef.current.value,
                    primaryPhone: this.priPhoneRef.current.value,
                    primaryEmail: this.priEmailRef.current.value,
                    secondaryContact: this.secContactRef.current.value,
                    secondaryPhone: this.secPhoneRef.current.value,
                    secondaryEmail: this.secEmailRef.current.value,
                }
                if(this.props.match.params.oemId != 0){
                    await updateOem(this.props.match.params.oemId, data);
                    this.setState({
                        scsMsg: "Oem Updated Successfully"
                    })
                } else {
                    await createOem(data);
                    this.setState({
                        scsMsg: "Oem created Successfully"
                    }, () => {
                        this.reset();
                    })
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    validate = () =>{
        let eml = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let errMsg;
        if (this.nameRef && this.nameRef.current.value == "") {
            this.nameRef.current.focus();
            errMsg= "Please enter a valid oem name";
        } else if (this.priEmailRef && this.priEmailRef.current.value != "" && !eml.test(this.priEmailRef.current.value)) {
            this.priEmailRef.current.focus();
            errMsg= "Please enter a valid primary email";
        } else if (this.secEmailRef && this.secEmailRef.current.value != "" && !eml.test(this.secEmailRef.current.value)) {
            this.secEmailRef.current.focus();
            errMsg= "Please enter a valid secondary email";
        } 
        if(errMsg){
            this.setState({errMsg: errMsg});
            return false;
        }
        return true;
    }

    reset = () => {
        this.nameRef.current.value = "";
        this.addressRef.current.value = "";
        this.priContactRef.current.value = "";
        this.priPhoneRef.current.value = "";
        this.priEmailRef.current.value = "";
        this.secContactRef.current.value = "";
        this.secPhoneRef.current.value = "";
        this.secEmailRef.current.value = "";
    }

    render() {

        return (
            
            <div className="width_100">
                <Card>
                    <CardHeader color="primary">
                        <h4><b>Oem Info</b></h4>
                    </CardHeader>
                    <CardBody>
                        {((this.state.errMsg && this.state.errMsg !== "") || (this.state.scsMsg && this.state.scsMsg !== "")) ? (
                            <SnackbarContent
                                message={
                                    this.state.errMsg !== ""
                                        ? this.state.errMsg
                                        : this.state.scsMsg !== ""
                                            ? this.state.scsMsg
                                            : ""
                                }
                                color={
                                    this.state.errMsg !== ""
                                        ? "warning"
                                        : this.state.scsMsg !== ""
                                            ? "success"
                                            : ""
                                }
                            />
                        ) : (
                            ""
                        )}    
                        <GridContainer>
                            <GridItem md={1}></GridItem>
                            <GridItem sm={12} md={10}>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label txt-col-blk">Name</label>
                                    <div className="col-sm-8">
                                        <input type="text" className="form-control" ref={this.nameRef}/>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label txt-col-blk">Address</label>
                                    <div className="col-sm-8">
                                        <textarea className="form-control" ref={this.addressRef} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label txt-col-blk">Primary Contact</label>
                                    <div className="col-sm-8">
                                        <input type="text" className="form-control" ref={this.priContactRef}/>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label txt-col-blk">Primary Email</label>
                                    <div className="col-sm-8">
                                        <input type="text" className="form-control" ref={this.priEmailRef}/>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label txt-col-blk">Primary Phone</label>
                                    <div className="col-sm-8">
                                        <input type="text" className="form-control" ref={this.priPhoneRef}/>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label txt-col-blk">Secondary Contact</label>
                                    <div className="col-sm-8">
                                        <input type="text" className="form-control" ref={this.secContactRef}/>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label txt-col-blk">Secondary Email</label>
                                    <div className="col-sm-8">
                                        <input type="text" className="form-control" ref={this.secEmailRef}/>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label txt-col-blk">Secondary Phone</label>
                                    <div className="col-sm-8">
                                        <input type="text" className="form-control" ref={this.secPhoneRef}/>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>  
                        <GridContainer>
                            <GridItem sm={12} md={12}>
                                
                                <Button
                                    type="button"
                                    variant="contained"
                                    className="float_rght"
                                    color="primary"
                                    onClick={this.postData.bind(this)}
                                >
                                    {this.props.match.params.oemId != 0 ? "Update": "Create"}
                                </Button>
                                <Button
                                    type="button"
                                    variant="contained"
                                    className="float_rght"
                                    onClick={this.navToList}
                                >
                                   Cancel
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>  
                </Card>
            </div>
        );
    }        
}

export default OemDetails;